const translations = {
  "en": {
    "Build a 6-month safety net": "Build a 6-month safety net",
    "ed:": "ed:",
    "Goal paywall progress": "Goal paywall progress",
    "It slipped out of the top 3 on profitability.": "It slipped out of the top 3 on profitability.",
    "Next goal paywall slide": "Next goal paywall slide",
    "now": "now",
    "NVDA ranking watch moved": "NVDA ranking watch moved",
    "Previous goal paywall slide": "Previous goal paywall slide",
    "Your goal": "Your goal"
  },
  "zh-tw": {
    "Build a 6-month safety net": "建立 6 個月的安全網",
    "ed:": "Ed：",
    "Goal paywall progress": "目標付費牆進度",
    "It slipped out of the top 3 on profitability.": "獲利能力排名已跌出前三名。",
    "Next goal paywall slide": "下一目標付費牆滑動面板",
    "now": "現在",
    "NVDA ranking watch moved": "NVDA 評級追蹤已更新",
    "Previous goal paywall slide": "上一個目標付費牆頁面",
    "Your goal": "您的目標"
  }
};

export default translations;
